import React, { useState, useEffect, ReactNode } from 'react'
import { Services } from '@/services/services'
import { Translates } from '@/services/repository/i18n'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { CurrentSession } from '@/services/repository/session'
import { useModal } from '../modal/Modal'
import './LoggedInLayout.css'
import { isDesktopScreen, useResponsiveChange } from '@/common/device'
import { NavigationMenu, NavigationRow } from './Navigation'
import { InnerLayout } from './InnerLayout'
import { squareLogo } from '@/env/config'
import { Spinner } from '../spinner'

export interface MainLayoutParams {
  pageName: string
  services: Services
  session: CurrentSession
  children: ReactNode
  navbarLeft?: ReactNode
  navbarRight?: ReactNode
  path?: NavigationRow[]
}

export const LangsPopup = ({ services, session, onClose }: { services: Services, session: CurrentSession, onClose: () => void }) => {
  function langRow(title: string, code: string) {
    return <li onClick={() => {
      services.session.setLang(code)
      onClose()
    }} className={session.user.lang === code ? 'current' : ''}>
      <div className='title'>{title}</div>
      <img src={`/public/img/flags/${code}.svg`} />
    </li>
  }
  return <div className='layout-navbar-langs'>
    <ul>
      {services.i18n.languages().map((lang) => langRow(session.translates.for('dicts.langs.' + lang), lang))}
    </ul>
  </div>
}

export const NavBar = ({ services, session, navbarLeft, navbarRight }: { services: Services, session: CurrentSession, navbarLeft?: ReactNode, navbarRight?: ReactNode }) => {
  const navigate = useNavigate()
  const location = useLocation()
  const { openModal } = useModal()

  useResponsiveChange()

  function redirect(url: string, external: boolean) {
    if (!external) {
      navigate(url)
      return
    }
    window.location.href = url
  }

  interface liProps {
    external?: boolean
    ico?: string
    onClick?: () => void
  }

  function li(title: string, url: string, row: liProps) {
    const { onClick = undefined, ico = undefined, external = false } = row
    return <li onClick={() => onClick ? onClick() : redirect(url, external)} className={location.pathname === url ? 'current' : ''}>
      <div className='wrap'>
        {isDesktopScreen() ? title : null}
        {ico ? <i className={'arrow ' + ico}></i> : <i className='svgfont-arrow-down arrow'></i>}
      </div>
    </li>
  }

  if (!session) {
    return <Spinner />
  }

  return (
    <nav className='dashboard-navbar'>
      <div className='navbar-body'>
        <div className='left-wrap'>
          {navbarLeft}
          {/* <ul>
            {li(session.translates.for('layout.navbar.home'), '/', { ico: 'svgfont-home' })}
            {li(session.translates.for('layout.navbar.langs'), '/langs', { ico: 'svgfont-earth', onClick: () => openModal((props) => LangsPopup({ ...props, session, services })) })}
            {li(session.translates.for('layout.navbar.logout'), '/logout', { ico: 'svgfont-logout' })}
          </ul> */}
        </div>
        <div className='logo-wrap'>
          <img src={squareLogo} />
        </div>
        <div className='right-wrap'>
          {navbarRight}
        </div>
      </div>
    </nav>
  )
}


export const LoggedInLayout = (params: MainLayoutParams) => {
  return <InnerLayout {...params} />

}

export const LoggedInPageLayout = (params: MainLayoutParams) => {
  return <LoggedInLayout {...params}>
    <NavigationMenu translates={params.session.translates} title={params.pageName} path={params.path}></NavigationMenu>
    {params.children}
  </LoggedInLayout>
}
